import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Emploi / contrat de travail — mallette duotone */
export const BriefcaseIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Loquet menthe */}
      <rect x="9" y="3" width="6" height="3" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Corps de la mallette */}
      <rect x="3" y="6" width="18" height="14" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Anse */}
      <path
        d="M9 6V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Bande horizontale */}
      <path d="M3 12h18" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Petit fermoir au centre */}
      <rect x="10.5" y="11" width="3" height="2" rx="0.5" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
BriefcaseIcon.displayName = "BriefcaseIcon";
